export const LEGACY_AUTH_KEYS = [
  "@ctech:token",
  "@ctech:refreshToken",
  "@ctech:tokenExpiration",
  "@ctech:tokenExpirationAt",
  "@ctech:refreshTokenExpiration",
  "@ctech:userId",
];

export function clearLegacyAuthStorage() {
  LEGACY_AUTH_KEYS.forEach((key) => localStorage.removeItem(key));
}

export function hasOidcUrlParams() {
  const params = new URLSearchParams(window.location.search);
  return (
    params.has("error") ||
    params.has("code") ||
    params.has("state") ||
    params.has("session_state")
  );
}

export function getOidcUrlError() {
  const params = new URLSearchParams(window.location.search);
  const error = params.get("error");

  if (!error) {
    return null;
  }

  return {
    error,
    errorDescription: params.get("error_description"),
  };
}

export function isAccessDeniedError(error: string | undefined | null) {
  return error === "access_denied";
}

export function cleanOidcUrlAndRedirect(path = "/") {
  if (window.location.pathname !== path || window.location.search) {
    window.history.replaceState({}, document.title, path);
  }
}

export function cleanOidcUrlAndRedirectHome() {
  cleanOidcUrlAndRedirect("/");
}
